import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d90258b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "info-content row" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-6\" data-v-3d90258b><div class=\"a global-title\" data-v-3d90258b><span data-v-3d90258b> IDP</span><span data-v-3d90258b> ( Intelligent Development Platform ) </span></div><div class=\"b global-title\" data-v-3d90258b>让AI更简单·更快速·更高效</div><div class=\"c global-title\" data-v-3d90258b> AI IDE + 高性能计算引擎</div></div><div class=\"col-1\" data-v-3d90258b></div>", 2)
const _hoisted_5 = { class: "col-5" }
const _hoisted_6 = { class: "from-scope" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "global-title title" }, "申请试用", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "some" }, "请留下咨询内容及联系方式，我们将在1个工作日内联系您", -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "mb-3 form-check" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = {
  class: "form-check-label",
  for: "exampleCheck1"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "提交", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VaildateInput = _resolveComponent("VaildateInput")!
  const _component_VaildateForm = _resolveComponent("VaildateForm")!
  const _component_Privacy = _resolveComponent("Privacy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_VaildateForm, { onFormSubmit: _ctx.onFormSubmit }, {
              submit: _withCtx(() => [
                _hoisted_18
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_VaildateInput, {
                    labelTxt: "姓名",
                    placeholder: "请填写您的姓名",
                    modelValue: _ctx.nameVal,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nameVal) = $event)),
                    rules: _ctx.nameRules,
                    type: "input"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_VaildateInput, {
                    labelTxt: "机构名称",
                    placeholder: "请填写您的机构名称",
                    modelValue: _ctx.companyVal,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyVal) = $event)),
                    rules: _ctx.companyRules,
                    type: "input"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_VaildateInput, {
                    labelTxt: "职位",
                    type: "select",
                    tag: "select",
                    modelValue: _ctx.positionVal,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.positionVal) = $event)),
                    options: _ctx.positionOption,
                    rules: _ctx.positionRules
                  }, null, 8, ["modelValue", "options", "rules"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_VaildateInput, {
                    labelTxt: "联系邮箱",
                    placeholder: "请填写您的工作邮箱用于接受邀请码",
                    modelValue: _ctx.emailVal,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailVal) = $event)),
                    rules: _ctx.emailRules,
                    type: "input"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_VaildateInput, {
                    labelTxt: "联系电话",
                    placeholder: "请填写您的手机号",
                    modelValue: _ctx.phoneVal,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneVal) = $event)),
                    rules: _ctx.phoneRules,
                    type: "input"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_VaildateInput, {
                    labelTxt: "渠道",
                    rules: _ctx.channelRules,
                    type: "select",
                    tag: "select",
                    modelValue: _ctx.channelVal,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.channelVal) = $event)),
                    options: _ctx.channelOption
                  }, null, 8, ["rules", "modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "form-check-input",
                    id: "exampleCheck1",
                    checked: _ctx.checked,
                    onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeChecked && _ctx.changeChecked(...args)))
                  }, null, 40, _hoisted_16),
                  _createElementVNode("label", _hoisted_17, [
                    _createTextVNode("我已阅读并同意 "),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePrivacyVisible(true)))
                    }, "《白海隐私政策》")
                  ]),
                  _withDirectives(_createElementVNode("div", {
                    id: "emailHelp",
                    class: "form-text invalid-feedback"
                  }, _toDisplayString(_ctx.checkedMessage), 513), [
                    [_vShow, _ctx.checkedMessage.length]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onFormSubmit"])
          ])
        ])
      ])
    ]),
    (_ctx.privacyVisible)
      ? (_openBlock(), _createBlock(_component_Privacy, {
          key: 0,
          changePrivacyVisible: _ctx.changePrivacyVisible
        }, null, 8, ["changePrivacyVisible"]))
      : _createCommentVNode("", true)
  ], 64))
}